import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import React from 'react';
import WarningIcon from 'src/components/Icons/WarningIcon';

export const ICON_MAP = {
  success: <CheckCircleOutlineIcon />,
  warning: <WarningIcon />,
  error: <HighlightOffIcon />,
  info: <InfoOutlinedIcon />,
};
